import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import "../css/ChemistCallFrequency.css"; 
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import Loader from "../dist/Loader";
const ChemistCallFrequency = () => {
  const navigate = useNavigate();
  const [states, setStates] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [validationErrors, setValidationErrors] = useState({
    state: false,
    division: false,
    employee: false,
  });
  const [tableData, setTableData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const tableRef = useRef();
  const getMonthYearOptions = () => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const currentYear = new Date().getFullYear();
    return months.map((month, index) => ({
      label: `${month} ${currentYear}`,
      value: `${String(index + 1).padStart(2, "0")}-${currentYear}`,
    }));
  };

  const monthYearOptions = getMonthYearOptions();
  const [pobMonthYear, setPobMonthYear] = useState(
    monthYearOptions[new Date().getMonth()].value
  );
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/states`, { headers: getAuthHeaders() })
      .then((res) => setStates(res.data))
      .catch((err) => console.error("Error fetching states:", err));
  }, []);

  const handleStateChange = async (stateId) => {
    setSelectedState(stateId);
    setSelectedDivision("");
    setSelectedEmployee("");
    setDivisions([]);
    setEmployees([]);
    setValidationErrors({ ...validationErrors, state: false });

    if (stateId) {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/divisions?state_id=${stateId}`,
          { headers: getAuthHeaders() }
        );
        setDivisions(response.data);
      } catch (err) {
        console.error("Error fetching divisions:", err);
        setError("Failed to load divisions");
      }
    }
  };

  const handleDivisionChange = async (divisionId) => {
    setSelectedDivision(divisionId);
    setSelectedEmployee("");
    setEmployees([]);
    setValidationErrors({ ...validationErrors, division: false });

    if (divisionId && selectedState) {
      try {
        const division = divisions.find((d) => d.id == divisionId);
        const divisionName = division?.name;

        if (!divisionName) {
          console.error("Division name not found for ID:", divisionId);
          return;
        }
        const response = await axios.get(
          `${BASE_URL}/api/employees?state_id=${selectedState}&division=${encodeURIComponent(
            divisionName
          )}`,
          { headers: getAuthHeaders() }
        );

        setEmployees(response.data);
      } catch (err) {
        console.error("Error fetching employees:", err);
        setError("Failed to load employees");
      }
    }
  };

  const validateForm = () => {
    const errors = {
      state: !selectedState,
      division: !selectedDivision,
      employee: !selectedEmployee,
    };
    setValidationErrors(errors);
    return !errors.state && !errors.division && !errors.employee;
  };

  const handleGoClick = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      setIsLoading(true);
      setError(null);

      const [month, year] = pobMonthYear.split("-").map(Number);
      const divisionObj = divisions.find((d) => d.id == selectedDivision);
      const divisionName = divisionObj?.name;

      if (!divisionName) {
        setError("Invalid division selected.");
        return;
      }

      const url = `${BASE_URL}/api/chemist/chemistcallfrequency?state_id=${selectedState}&division_id=${encodeURIComponent(
        divisionName
      )}&employee_id=${selectedEmployee}&month=${month}&year=${year}`;

      const response = await axios.get(url);
      setTableData(response.data);
      setShowTable(true);
    } catch (err) {
      console.error("Failed to fetch summary", err);
      setError("Failed to load data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedState) {
      handleGoClick();
    }
  }, [pobMonthYear]);

  const handlePrint = () => {
    const printContent = tableRef.current.innerHTML;

    const printWindow = window.open("", "_blank", "width=900,height=600");
    if (printWindow) {
      printWindow.document.write(`
            <html>
            <head>
                <title>Print Table</title>
                <style>
                body {
                    font-family: Arial, sans-serif;
                    padding: 20px;
                }
                table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 14px;
                }
                th, td {
                    border: 1px solid #ccc;
                    padding: 8px;
                    text-align: left;
                }
                th {
                    background-color: #f2f2f2;
                }
                </style>
            </head>
            <body>
                <h2>Stockist Data</h2>
                ${printContent}
                <script>
                window.onload = function() {
                    window.print();
                }
                </script>
            </body>
            </html>
        `);
      printWindow.document.close();
    }
  };

  const handleExport = () => {
    const XLSX = require("xlsx");

    const ws = XLSX.utils.table_to_sheet(
      tableRef.current.querySelector("table")
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "StockistData");

    XLSX.writeFile(wb, "stockist_data.xlsx");
  };

  return (
    <div className="ChemistCallFrequency-main">
      {isLoading && <Loader />}
      <div
        className={`main-container ${
          isLoading ? "blur-sm pointer-events-none" : ""
        }`}
      >
        <div className="ChemistCallFrequency-filter-container">
          <h1 class="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
            <span class="text-blue-700"> Select </span>
            <span class="text-blue-500">Employee</span>
          </h1>
          <div className="ChemistCallFrequency-filter-row1">
            <label className="ChemistCallFrequency-label">State:</label>
            <select
              className={`ChemistCallFrequency-dropdown ${
                validationErrors.state ? "error" : ""
              }`}
              value={selectedState}
              onChange={(e) => handleStateChange(e.target.value)}
              disabled={isLoading}
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.name}
                </option>
              ))}
            </select>
            {validationErrors.state && (
              <span className="required-text">* Required</span>
            )}

            <label className="ChemistCallFrequency-label">Division:</label>
            <select
              className={`ChemistCallFrequency-dropdown ${
                validationErrors.division ? "error" : ""
              }`}
              value={selectedDivision}
              onChange={(e) => handleDivisionChange(e.target.value)}
              required
              // disabled={!selectedState || isLoading}
            >
              <option value="">Select Division</option>
              {divisions.map((division) => (
                <option key={division.id} value={division.id}>
                  {division.name}
                </option>
              ))}
            </select>
            {validationErrors.division && (
              <span className="required-text">* Required</span>
            )}
          </div>

          <div className="ChemistCallFrequency-filter-row2">
            <label className="ChemistCallFrequency-label">Employee:</label>
            <select
              className={`ChemistCallFrequency-dropdown ${
                validationErrors.employee ? "error" : ""
              }`}
              value={selectedEmployee}
              onChange={(e) => {
                setSelectedEmployee(e.target.value);
                setValidationErrors({ ...validationErrors, employee: false });
              }}
              required
            >
              <option value="">Select Employee</option>
              {employees.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {`${emp.first_name} ${emp.last_name} | ${emp.designation} | ${emp.headquarter_name} | ${emp.division} | ${emp.state_name}`}
                </option>
              ))}
            </select>
            {validationErrors.employee && (
              <span className="required-text">* Required</span>
            )}

            <label className="ChemistCallFrequency-label">Month / Year:</label>
            <select
              className="ChemistCallFrequency-dropdown"
              value={pobMonthYear}
              onChange={(e) => setPobMonthYear(e.target.value)}
              // disabled={isLoading}
            >
              {monthYearOptions.map((option, idx) => (
                <option key={idx} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <button
            className="ChemistCallFrequency-go-button"
            onClick={handleGoClick}
            disabled={isLoading || !selectedState}
          >
            {isLoading ? "Loading..." : "GO"}
          </button>

          {error && <div className="ChemistCallFrequency-error">{error}</div>}
        </div>
        {showTable && (
          <>
            {/* Table container */}
            <div className="ChemistCallFrequency-table-container">
              <div className="ChemistCallFrequency-title3-container">
                <h2 className="ChemistCallFrequency-title3">
                  {states.find((s) => s.id == selectedState)?.name ||
                    selectedState}{" "}
                  - All Assigned Chemist
                </h2>
              </div>

              <div
                className="ChemistCallFrequency-table-wrapper"
                ref={tableRef}
              >
                <table className="ChemistCallFrequency-table">
                  <thead className="text-white">
                    <tr>
                      <th>S.No</th>
                      <th>Chemist</th>
                      <th>Days</th>
                      <th>Frequency</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((item, index) => (
                      <tr key={item.stockist_code || index}>
                        <td>{index + 1}</td>
                        <td>{item.chemist_name}</td>
                        <td>{item.visit_dates || "No visits"}</td>
                        <td>{item.frequency}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* ✅ Buttons outside the table container */}
            <div className="ChemistCallFrequency-button-group">
              <button
                className="ChemistCallFrequency-print-btn"
                onClick={handlePrint}
              >
                Print
              </button>
              <button
                className="ChemistCallFrequency-export-btn"
                onClick={handleExport}
              >
                Export to Excel
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ChemistCallFrequency;
